<template>
    <div class="page-notice">
        <!-- <div class="radio-btn">
            <el-radio-group v-model="ptType" @input="ptTypeChange">
                <el-radio-button label="noticesys">
                    <span class="radio-text">平台内</span>
                </el-radio-button>
                <el-radio-button label="notice">
                    <span class="radio-text">行业</span>
                </el-radio-button>
            </el-radio-group>
        </div> -->

        <SearchHead v-model="pgData.searchcontent" @search="$refs.page.queryData()" @reset="$refs.page.queryData()">
            <!-- <div class="btn-box">
                <div :class="['my-btn' , ptType == 'noticesys' ? 'btn-active' :'' ]" @click="goto('/noticesys')">
                    平台内
                </div>
                /
                <div :class="['my-btn' , ptType == 'notice' ? 'btn-active' :'' ]" @click="goto('/notice')">
                    行业
                </div>
            </div> -->
        </SearchHead>

        <div class="content">
            <div class="search-card">
                <div class="row">
                    <div class="label">
                        项目区域：
                    </div>

                    <div class="con">
                        <my-select size="small" v-model="pgData.citycode" :data="cityList"
                            :props="{label: 'name', value: 'cityid'}" @select="$refs.page.queryData()"></my-select>
                    </div>
                </div>

                <div class="row">
                    <div class="label">
                        招标内容：
                    </div>

                    <div class="con">
                        <SelectTab :showAll="false" :data="ggType" v-model="pgData.type"
                            @select="$refs.page.queryData()" :props="{label: 'name', value: 'type',}"></SelectTab>
                    </div>
                </div>
                <div class="row">
                    <div class="label">
                        项目类型：
                    </div>

                    <div class="con">
                        <SelectTab :showAll="false" :data="proTypes" v-model="pgData.leixing"
                            :props="{label: 'label', value: 'label',}" @select="$refs.page.queryData()"></SelectTab>
                    </div>
                </div>
            </div>

            <commonList :tableData="tableData" showTag :loading="loading" :createUrl="buildDetailUrl"
                titleBefore="typename" name="ggname" time="ggfbtime" area="cityname" noticetype="leixing"
                endtime="ggendtime">
                <!-- <div slot='title'>{{item[name]}}</div> -->
            </commonList>

            <!-- {{tableData}} -->

            <sysPaginationVue ref="page" v-model="tableData" :loading.sync="loading" :search="pgData"
                :action="`${$store.state.api.webUrl}/index/information/getjyinfopg.json`"></sysPaginationVue>
        </div>
    </div>
</template>

<script>
import SearchHead from '@components/sys/search-head.vue';
import SelectTab from '@components/sys/select-tab.vue';


import commonList from '@/pages/notice/components/common-list.vue';

import sysPaginationVue from '@components/sys/sys-pagination.vue';



export default {
    components: {
        SearchHead,
        SelectTab,

        commonList,
        sysPaginationVue,
    },
    data () {
        return {
            pgData: {
                searchtype: 'ggname',
                searchcontent: this.$route.query.searchcontent || '',
                type: 'zbgg',
                leixing: '全部',
                citycode: this.webInfo.citycode,
                featurecode: this.webInfo.planname,

                sortname: '',
                sortorder: 'desc',
                pagesize: 20,
                pageindex: 1,
            },

            loading: true,

            tableData: [],


            ptType: '',

            ggType: [
                {
                    name: '招标公告',
                    type: 'zbgg',
                    id: '1',
                },
                {
                    name: '变更公告',
                    type: 'bggg',
                    id: '2',
                },
                {
                    name: '补遗答疑',
                    type: 'bydy',
                    id: '3',
                },
                {
                    name: '中标候选人公示',
                    type: 'hxrgs',
                    id: '4',
                },
                {
                    name: '中标公告',
                    type: 'zhongbiaogg',
                    id: '5',
                },
                {
                    name: '异常公告',
                    type: 'ycgg',
                    id: '6',
                },
            ],
            proTypes: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: 'jsgc',
                    label: '建设工程'
                },
                // {
                //     value: 'zfcg',
                //     label: '政府采购'
                // },
            ],
            cityList: [],
        };
    },
    methods: {
        buildDetailUrl (item) {
            // var { guid, noticetype } = item;
            var guid = item.ggcode;

            var search = toSearch({
                ggcode: item.ggcode,
                categoryid: item.ggtype,
                featurecode: this.webInfo.planname,
            });

            if (/SD/.test(item.ggcode)) {
                return `/noticesys/detail-sd${search}`;
            }

            return `/noticesys/${guid}${search}`;
        },


        getType () {
            this.ptType = this.$route.name;
        },
        ptTypeChange (val) {
            if (this.$route.name == 'notice') {
                this.goto('/noticesys');
            } else {
                this.goto('/notice');
            }
        },

        queryCity () {
            this.$get(`${this.$store.state.api.webUrl}/index/information/getcitylist.json`, {
                parentid: this.webInfo.citycode,
            }, (data, res) => {
                data = res.tdata;
                this.cityList = data;
                this.cityList.unshift({
                    name: '全部',
                    cityid: this.webInfo.citycode,
                });
            });
        },

    },
    mounted () {
        this.queryCity();

        this.getType();
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.btn-box {
    font-size: 24px;
    width: 300px;
    margin: 0 auto;
    padding-bottom: 15px;
    margin-top: -15px;
    display: flex;
    justify-content: space-around;
    .my-btn{
        cursor: pointer;
        &:hover{
            color: $primaryColor;
        }
    }
    .btn-active{
        color: $primaryColor;
    }
}

.page-notice {
    padding-bottom: 40px;
    min-height: 600px;
    position: relative;
}

.radio-btn {
    // margin: 0 auto;
    // width: 1200px;
    position: absolute;
    top: 10px;
    left: calc(50% - 600px);
    z-index: 999;

    ::v-deep .el-radio-button__inner {
        padding: 6px 10px;
    }
    .radio-text {
        font-size: 16px;
    }
}

.search-card {
    box-shadow: 0px 9px 27px 0px #e8eaef;
    border: solid 3px #ffffff;
    background-image: linear-gradient(180deg, #f5f7f9 0%, #fefefe 100%);
    padding: 21px 15px;
    margin-top: 26px;

    .row {
        display: flex;
        align-items: center;

        .label {
            font-size: 16px;
            color: #1b1b1b;
            font-weight: bold;
        }

        .con {
            display: flex;
        }

        & + .row {
            margin-top: 25px;
        }
    }
}
</style>